<script setup lang="ts">
useSeoMeta({
  title: 'Mentions Légales - Ohmelec',
  robots: 'noindex, nofollow' // Bloque l'indexation par les moteurs de recherche
})
</script>

<template>
  <div class="pt-32 pb-24 sm:pt-40 sm:pb-32 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
    <h1 class="text-3xl sm:text-4xl font-bold tracking-tight mb-12">Mentions Légales</h1>

    <div class="space-y-10 text-dimmed leading-relaxed">
      <section class="space-y-2 p-6 rounded-2xl bg-white/5 border border-white/10">
        <p><strong>Ohmelec</strong>, 19 Rue Henri Barbusse, 30000 Nîmes</p>
        <p>Code APE : 4321A | SIRET : 87811954400020</p>
        <p><strong>Directeur de publication :</strong> Joaquim Letailleur, gérant</p>
        <p><strong>Réalisation :</strong> MigL-Consulting - <a href="https://migl-consulting.fr" target="_blank" class="text-primary hover:underline">migl-consulting.fr</a></p>
        <p><strong>Hébergement :</strong> Cloudflare Inc., 101 Townsend St, San Francisco, CA 94107, USA</p>
      </section>

      <section class="space-y-4">
        <h2 class="text-xl font-semibold text-white">I/ Objet</h2>
        <p>Les Conditions d’utilisation présentent les droits et obligation des utilisateurs et constituent le contrat qui les lie à Ohmelec. Ohmelec se réserve le droit de modifier à tout moment ces Conditions d’utilisation.</p>
      </section>

      <section class="space-y-4">
        <h2 class="text-xl font-semibold text-white">II/ Définitions</h2>
        <p>Dans le cadre des présentes Conditions d’utilisation, les termes et expressions identifiés par une majuscule ont la signification indiquée ci-après :</p>
        <ul class="list-disc pl-5 space-y-2">
          <li><strong>« Conditions d’utilisation »</strong> désigne les présents termes et conditions générales d’utilisation du site Ohmelec.net ;</li>
          <li><strong>« Parties prenantes »</strong> désigne l’ensemble des contributeurs ayant publié sur le site ;</li>
          <li><strong>« Contribution »</strong> désigne toute œuvre que les parties prenantes publient sur le site ;</li>
          <li><strong>« Site »</strong> désigne le site internet Ohmelec.net ;</li>
          <li><strong>« Utilisateur »</strong> désigne une personne qui utilise le site Ohmelec.net.</li>
        </ul>
      </section>

      <section class="space-y-4">
        <h2 class="text-xl font-semibold text-white">III/ Droits et obligations de l’utilisateur</h2>
        <p>L’utilisateur d’une manière générale, utilise les informations présentes sur le site Ohmelec.net d’une façon responsable et professionnelle et s’abstient d’agir de manière illicite, diffamatoire ou injurieuse.</p>
        <p>Il s’engage à ne pas distribuer de spam, virus ou autres technologies qui peuvent nuire au site. L’utilisateur s’engage à ne pas utiliser de robot, spider ou d’autres moyens automatisés pour accéder à nos services.</p>
        <p>En cas de non-respect, nous pouvons, à notre seule discrétion, prendre toutes mesures techniques et juridiques pour vous empêcher d’utiliser nos services.</p>
      </section>

      <section class="space-y-4">
        <h2 class="text-xl font-semibold text-white">IV/ Confidentialité et cookies</h2>
        <h3 class="text-lg font-medium text-white/80 mt-4">A/ Propriété intellectuelle</h3>
        <p>La plateforme est protégée au titre des dispositions relatives au droit d’auteur. Ohmelec est titulaire de l’ensemble des droits de propriété intellectuelle sur les éléments composant son site internet.</p>

        <h3 class="text-lg font-medium text-white/80 mt-4">B/ Confidentialité</h3>
        <p>L’utilisateur est responsable de l’utilisation des formulaires et veille au maintien de la confidentialité de son identification.</p>

        <h3 class="text-lg font-medium text-white/80 mt-4">C/ Cookies</h3>
        <p>Ohmelec utilise des cookies. Ces cookies enregistrent uniquement des informations relatives à la navigation. L’utilisateur peut s’opposer à l’enregistrement de cookies en configurant son navigateur.</p>
      </section>

      <section class="space-y-4">
        <h2 class="text-xl font-semibold text-white">V/ Protection des données personnelles</h2>
        <p>Dans le cadre de son activité, Ohmelec est susceptible de collecter et traiter des données à caractère personnel. L’ensemble des traitements respecte la règlementation applicable (RGPD).</p>
        <p>Pour connaitre la nature de ces données, notre Politique de protection des données personnelles est consultable sur la page dédiée.</p>
      </section>
    </div>
  </div>
</template>
